module.exports = __webpack_public_path__ + "img/shaungzhou.47326ca9.png";